import { Map } from "immutable";
import { authenticationConstants } from "../constants/constants";
import * as AuthService from "../helpers/auth";

function setState(state, newState) {
  return state.merge(newState);
}

function loginRequest(state, newState) {
  return state
    .update("isFetching", isFetching => newState.isFetching)
    .update("error", error => newState.error);
}

function loginSuccess(state, newState) {
  return state
    .update("isFetching", isFetching => newState.isFetching)
    .update("isAuthenticated", isAuthenticated => newState.isAuthenticated)
    .update("profile", profile => Map(newState.profile))
    .update("expiryDate", expiryDate => newState.expiryDate)
    .update("accessToken", accessToken => newState.accessToken);
}

function loginError(state, newState) {
  return state
    .update("isFetching", isFetching => newState.isFetching)
    .update("isAuthenticated", isAuthenticated => newState.isAuthenticated)
    .update("profile", profile => Map(newState.profile))
    .update("error", error => newState.error);
}

function logoutSuccess(state, newState) {
  return state
    .update("isAuthenticated", isAuthenticated => newState.isAuthenticated)
    .update("profile", profile => Map(newState.profile));
}

export function authenticationReducer(state = Map(), action) {
  switch (action.type) {
    case authenticationConstants.SET_STATE_AUTH:
      return setState(state, action.state);
    case authenticationConstants.LOGIN_REQUEST:
      return loginRequest(state, {
        isFetching: true,
        error: null
      });
    case authenticationConstants.LOGIN_SUCCESS:
      return loginSuccess(state, {
        isFetching: false,
        isAuthenticated: true,
        profile: action.payload.profile,
        expiryDate: AuthService.getTokenExpirationDate(),
        accessToken: action.payload.accessToken
      });
    case authenticationConstants.LOGIN_ERROR:
      return loginError(state, {
        isFetching: false,
        isAuthenticated: false,
        profile: {},
        expiryDate: null,
        error: action.error,
        accessToken: ""
      });
    case authenticationConstants.LOGOUT_SUCCESS:
      return logoutSuccess(state, {
        isAuthenticated: false,

        profile: {},
        expiryDate: null,
        accessToken: ""
      });
    case authenticationConstants.HISTORY:
      return state;
    default:
      return setState(state, {
        isAuthenticated: AuthService.hasAccessToken()
          ? !AuthService.isTokenExpired()
          : false,
        isFetching: false,
        profile: Map(AuthService.getProfile()),
        expiryDate: AuthService.hasAccessToken()
          ? AuthService.getTokenExpirationDate()
          : null,
        error: null,
        accessToken: AuthService.hasAccessToken()
          ? AuthService.getAccessToken()
          : null
      });
  }
}
